import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector, useStore } from 'react-redux';
import {
  selectHasUnsavedChanges,
  setLastSavedHistoryLength,
  setHasUnsavedChanges,
} from '../store/slices/editorUISlice';

export function useUnsavedChanges() {
  const hasUnsavedChanges = useSelector(selectHasUnsavedChanges);

  // Browser navigation warning
  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (hasUnsavedChanges) {
        e.preventDefault();
        e.returnValue = 'You have unsaved changes. Are you sure you want to leave?';
        return 'You have unsaved changes. Are you sure you want to leave?';
      }
      return undefined;
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, [hasUnsavedChanges]);

  return {
    hasUnsavedChanges,
  };
}

export function useDirtyHelpers() {
  const dispatch = useDispatch();
  const store = useStore();

  const markClean = useCallback(() => {
    const currentHistoryLength = store.getState().undoRedo.past.length;
    dispatch(setLastSavedHistoryLength(currentHistoryLength));
    dispatch(setHasUnsavedChanges(false));
  }, [dispatch, store]);

  return {
    markClean,
  };
}

